
export default {
  name: 'InfoAlert',

  props: {
    type: {
      type: String,
      validator(value) {
        return ['info', 'error', 'success', 'warning'].includes(value);
      },
    },

    dense: {
      type: Boolean,
      default: true,
    },

    iconName: {
      type: String,
      default: 'info',
    },

    defaultIcon: {
      type: [Boolean, String],
      default: false,
    },

    text: {
      type: Boolean,
      default: true,
    },

    color: {
      type: String,
    },

    backgroundColor: {
      type: String,
      default: 'grey lighten-2',
    },
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
